var lib_core = require("lib-core");

var PackageGenerationManagerStateMachine = require("./packageGenerationManagerStateMachine.js");
var MasterController = require("ui-extensions").MasterController;

var PackageGenerationManagerController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};

lib_core.inherit(PackageGenerationManagerController, lib_core.Controller);
module.exports = PackageGenerationManagerController;

PackageGenerationManagerController.inject = {   
    masterController : MasterController
};

PackageGenerationManagerController.prototype.afterLoad = function () {
    var self = this;
    var stateMachineCreator = function(){
        return new PackageGenerationManagerStateMachine(self.root, self.generatorStateMachine);
    };
    this.masterController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};

PackageGenerationManagerController.prototype.registerGenerator = function (generatorController) {
    this.generatorStateMachine = generatorController.getStatemachine(); 
};